<template>
  <div class="bread-crumb">
    <div class="bread-crumb__item" v-for="(item, index) in breadCrumb" :key="index">
      <span class="item-name">{{ item }}</span>
      <span v-if="index !== breadCrumb.length - 1">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.60039 7.2002L14.4004 12.0002L9.60039 16.8002"
            stroke="#DBDBDB"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    breadCrumb: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped lang="scss">
.bread-crumb {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: flex-end;
  margin-bottom: 24px;
  .bread-crumb__item {
    display: flex;
    align-items: center;
    gap: 4px;
    .item-name {
      color: #909090;
      font-family: Pretendard;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 125%; /* 17.5px */
      letter-spacing: -0.18px;
      &:last-child {
        color: #000000;
      }
    }
  }
}
</style>
